import application from 'application/application';

import template from './default.template.html';

import menuBarTemplate from './partials/menu-bar.template.html';

import controller from './default.controller';

application

	.config(['$stateProvider', $stateProvider => {

		$stateProvider

			.state('root.default', {
				abstract: true,
				views: {
					'root': {
						templateUrl: template,
						controller
					},
					'menuBar@root.default': {
						templateUrl: menuBarTemplate
					}
				},
				params: {
					authentication: true
				}
			});

	}]);
